'use client';

import { forwardRef, HTMLAttributes } from 'react';
import styles from './Backdrop.module.css';

interface BackdropProps extends HTMLAttributes<HTMLDivElement> {
  open?: boolean;
}

const Backdrop = forwardRef<HTMLDivElement, BackdropProps>(({
  open = true,
  className = '',
  ...props
}, ref) => {
  if (!open) return null;

  return (
    <div
      ref={ref}
      className={[styles.backdrop, className].filter(Boolean).join(' ')}
      aria-hidden="true"
      {...props}
    />
  );
});

Backdrop.displayName = 'Backdrop';
export default Backdrop;
